import * as Actions from '../actions';

const initialState = {
    pengguna : {
        rows: [],
        total: 0
    },
    peran: {},
    hasil_tukar_pengguna: {},
    toggle_form_pengguna: {
        toggle: false,
        title: 'Form Pengguna -'
    },
    log_login: {
        rows:[],
        total: 0
    },
    log_simpan_jawaban: {
        rows:[],
        total: 0
    },
    badge_pengguna: {
        rows: [],
        total: 0
    },
    hasil_badge_pengguna: {
        rows: [],
        total: 0
    },
    hasil_pengguna: {
        rows: [],
        total: 0
    },
    semua_badge: {},
    pd_dapodik: {
        rows: [],
        total: 0
    },
    ptk_dapodik: {
        rows: [],
        total: 0
    },
    pengguna_mengerjakan: {
        rows: [],
        total: 0
    },
};

const penggunaReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_PENGGUNA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                pengguna: action.payload
            };
        }
        case Actions.GET_PENGGUNA_MENGERJAKAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                pengguna_mengerjakan: action.payload
            };
        }
        case Actions.GET_PERAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                peran: action.payload
            };
        }
        case Actions.TUKAR_PENGGUNA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_tukar_pengguna: action.payload
            };
        }

        case Actions.TOGGLE_FORM_PENGGUNA:
        {
            return {
                ...state,
                toggle_form_pengguna: action.toggle_form_pengguna
            };
        }
        
        case Actions.GET_LOG_LOGIN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                log_login: action.payload
            };
        }
        
        case Actions.GET_LOG_SIMPAN_JAWABAN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                log_simpan_jawaban: action.payload
            };
        }
        
        case Actions.GET_BADGE_PENGGUNA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                badge_pengguna: action.payload
            };
        }
        
        case Actions.SET_BADGE_PENGGUNA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_badge_pengguna: action.payload
            };
        }
        
        case Actions.GET_SEMUA_BADGE:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                semua_badge: action.payload
            };
        }

        case Actions.SET_PENGGUNA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_pengguna: action.payload
            };
        }
        
        case Actions.HAPUS_PENGGUNA:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                hasil_hapus_pengguna: action.payload
            };
        }

        case Actions.GET_PESERTA_DIDIK_DAPODIK:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                pd_dapodik: action.payload
            };
        }
        
        case Actions.GET_PTK_DAPODIK:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                ptk_dapodik: action.payload
            };
        }

        default:
        {
            return state;
        }
    }
}

export default penggunaReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/Pengguna.reducers.js